// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, schema de busca, catálogo e o
// carregador da tela. Outro módulo usa a `public.ts` (A06).
export { DIMENSA_SUBMISSION_PATH, dimensaSubmissionScreen } from './dimensa-submission.screen';
export { dimensaSubmissionSearch } from './dimensa-submission.search';
export { loadDimensaSubmissionMessages } from './dimensa-submission.catalog';

/** A tela da rota (`DimensaSubmissionRouteScreen`), por `lazyScreen`. */
export const loadDimensaSubmissionScreens = () => import('./dimensa-submission.page');

/** O guia da tela para o Luy (U46), sob demanda. */
export const loadDimensaSubmissionGuides = () => import('./dimensa-submission.guide');
